(function () {
  var STORAGE_KEY = 'sc_recently_viewed';
  var MAX_STORED = 20;

  function getStoredItems() {
    try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
      return raw.map(function (item) {
        if (typeof item === 'string') return { h: item, r: 0, rc: 0 };
        return item;
      });
    } catch (e) {
      return [];
    }
  }

  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js')
      .then(function (res) {
        if (!res.ok) throw new Error('Not found');
        return res.json();
      });
  }

  function formatMoney(cents) {
    var currency = window.Shopify && window.Shopify.currency ? window.Shopify.currency.active : 'AUD';
    var locale = window.Shopify && window.Shopify.locale ? window.Shopify.locale : 'en-AU';
    var formatted = new Intl.NumberFormat(locale, {
      style: 'currency',
      currency: currency,
      minimumFractionDigits: 2,
    }).format((cents || 0) / 100);
    return formatted.replace('A$', '$').replace('AU$', '$');
  }

  function escapeHtml(str) {
    var el = document.createElement('span');
    el.textContent = str || '';
    return el.innerHTML;
  }

  function escapeAttr(str) {
    return (str || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function buildCard(product, meta) {
    var variant = product.variants[0];
    var image = product.featured_image || (product.images && product.images[0]) || '';
    var price = variant ? variant.price : product.price;
    var available = variant ? variant.available : true;
    var variantId = variant ? variant.id : '';
    var iconCart = window.scIconCart || '';
    var iconStar = window.scIconStar || '';
    var iconChat = window.scIconChat || '';

    var rating = meta ? meta.r : 0;
    var reviewCount = meta ? meta.rc : 0;

    var statsHtml = '';
    if (rating > 0) {
      statsHtml += '<span class="chemical-by-need__stat">';
      if (iconStar) statsHtml += '<img src="' + escapeAttr(iconStar) + '" alt="" width="20" height="20">';
      statsHtml += ' ' + rating + '</span>';
    }
    if (reviewCount > 0) {
      statsHtml += '<span class="chemical-by-need__stat">';
      if (iconChat) statsHtml += '<img src="' + escapeAttr(iconChat) + '" alt="" width="20" height="20">';
      statsHtml += ' ' + reviewCount + '</span>';
    }

    var html =
      '<article class="chemical-by-need__product swiper-slide">' +
        '<a class="chemical-by-need__product-media" href="/products/' + product.handle + '">' +
          (image ? '<img src="' + escapeAttr(image) + '" alt="' + escapeAttr(product.title) + '" loading="lazy">' : '') +
        '</a>' +
        '<div class="chemical-by-need__product-body">' +
          '<div class="chemical-by-need__product-info">' +
            '<p class="chemical-by-need__product-name"><a href="/products/' + product.handle + '">' + escapeHtml(product.title) + '</a></p>' +
            '<div class="chemical-by-need__product-meta">' +
              '<div class="chemical-by-need__product-stats">' + statsHtml + '</div>' +
              '<p class="chemical-by-need__product-price">' + formatMoney(price) + '</p>' +
            '</div>' +
          '</div>' +
          '<button class="chemical-by-need__product-cta" type="button" data-rv-add data-variant-id="' + variantId + '"' + (!available ? ' disabled' : '') + '>' +
            (available ? 'Add to cart' : 'Sold out') +
            (iconCart ? ' <img src="' + escapeAttr(iconCart) + '" alt="" width="20" height="20">' : '') +
          '</button>' +
        '</div>' +
      '</article>';

    return html;
  }

  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    }).then(function (res) {
      if (!res.ok) throw new Error('Failed');
      return res.json();
    });
  }

  function initSection(section) {
    if (!section || section.dataset.rvReady === 'true') return;
    section.dataset.rvReady = 'true';

    var limit = parseInt(section.getAttribute('data-rv-limit'), 10) || 10;
    var slidesContainer = section.querySelector('[data-rv-slides]');
    var swiperEl = section.querySelector('[data-rv-swiper]');
    var progressEl = section.querySelector('[data-rv-progress]');
    var prevBtns = section.querySelectorAll('[data-rv-prev]');
    var nextBtns = section.querySelectorAll('[data-rv-next]');

    if (!slidesContainer || !swiperEl) return;

    var currentHandle = '';
    var pathParts = window.location.pathname.split('/products/');
    if (pathParts[1]) {
      currentHandle = pathParts[1].split('?')[0].split('#')[0].replace(/\/$/, '');
    }

    var items = getStoredItems().filter(function (item) { return item.h !== currentHandle; });
    if (!items.length) return;

    items = items.slice(0, limit);

    var fetches = items.map(function (item) {
      return fetchProduct(item.h)
        .then(function (product) { return { product: product, meta: item }; })
        .catch(function () { return null; });
    });

    Promise.all(fetches).then(function (results) {
      results = results.filter(Boolean);
      if (!results.length) return;

      var html = '';
      results.forEach(function (r) { html += buildCard(r.product, r.meta); });
      slidesContainer.innerHTML = html;

      section.hidden = false;

      if (typeof Swiper === 'undefined') return;

      var swiper = new Swiper(swiperEl, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        grabCursor: true,
        watchOverflow: true,
        pagination: { el: progressEl, type: 'progressbar' },
        breakpoints: { 769: { spaceBetween: 14 } }
      });

      function updateNav() {
        prevBtns.forEach(function (btn) {
          btn.disabled = swiper.isBeginning;
          btn.classList.toggle('swiper-button-disabled', swiper.isBeginning);
        });
        nextBtns.forEach(function (btn) {
          btn.disabled = swiper.isEnd;
          btn.classList.toggle('swiper-button-disabled', swiper.isEnd);
        });
      }

      swiper.on('init', updateNav);
      swiper.on('slideChange', updateNav);
      swiper.on('reachBeginning', updateNav);
      swiper.on('reachEnd', updateNav);
      swiper.on('fromEdge', updateNav);
      updateNav();

      prevBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { swiper.slidePrev(); });
      });
      nextBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { swiper.slideNext(); });
      });

      section.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-rv-add]');
        if (!btn || btn.disabled) return;

        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;

        var originalHtml = btn.innerHTML;
        btn.disabled = true;
        btn.textContent = 'Adding...';

        addToCart(variantId)
          .then(function () {
            document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { openDrawer: true } }));
          })
          .catch(function () {})
          .then(function () {
            btn.disabled = false;
            btn.innerHTML = originalHtml;
          });
      });
    });
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-recently-viewed]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) initAll(event.target);
  });
})();
